export const CONSTRUCTION_WAVE1_REMOVED_SLUGS: ReadonlySet<string> = new Set([
  "construction-air-source-calculator",
  "construction-airtightness-calculator",
  "construction-architrave-length-calculator",
  "construction-asphalt-area-calculator",
  "construction-balcony-load-calculator",
  "construction-balustrade-calculator",
  "construction-bathroom-ventilation-calculator",
  "construction-battery-storage-calculator",
  "construction-block-count-calculator",
  "construction-boundary-setback-calculator",
  "construction-breeam-score-calculator",
  "construction-brick-count-calculator",
  "construction-cable-size-calculator",
  "construction-cavity-wall-fill-calculator",
  "construction-cesspit-calculator",
  "construction-cold-bridge-calculator",
  "construction-collar-tie-calculator",
  "construction-column-load-calculator",
  "construction-cylinder-size-calculator",
  "construction-deck-boards-calculator",
  "construction-decking-area-calculator",
  "construction-door-frame-calculator",
  "construction-drainage-gradient-calculator",
  "construction-drywall-sheets-calculator",
  "construction-epc-rating-calculator",
  "construction-excavation-calculator",
  "construction-fire-escape-calculator",
  "construction-foundation-depth-calculator",
  "construction-garden-wall-calculator",
  "construction-grey-water-calculator",
  "construction-ground-source-calculator",
  "construction-gully-spacing-calculator",
  "construction-handrail-length-calculator",
  "construction-hardcore-base-calculator",
  "construction-hip-rafter-calculator",
  "construction-hot-tub-size-calculator",
  "construction-immersion-heater-calculator",
  "construction-insulation-area-calculator",
  "construction-inverter-size-calculator",
  "construction-irrigation-area-calculator",
  "construction-joist-spacing-calculator",
  "construction-kerb-length-calculator",
  "construction-kitchen-extract-calculator",
  "construction-landscaping-area-calculator",
  "construction-lawn-seed-calculator",
  "construction-lighting-circuit-calculator",
  "construction-lintel-size-calculator",
  "construction-loft-insulation-calculator",
  "construction-mortar-mix-calculator",
  "construction-mvhr-system-calculator",
  "construction-outdoor-cable-calculator",
  "construction-padstone-calculator",
  "construction-pergola-load-calculator",
  "construction-permitted-development-calculator",
  "construction-pile-cap-calculator",
  "construction-plaster-area-calculator",
  "construction-purlin-spacing-calculator",
  "construction-radiator-size-calculator",
  "construction-rcd-trip-calculator",
  "construction-render-area-calculator",
  "construction-retaining-wall-calculator",
  "construction-road-construction-calculator",
  "construction-roof-pitch-calculator",
  "construction-room-area-calculator",
  "construction-sap-rating-calculator",
  "construction-scaffold-area-calculator",
  "construction-screed-volume-calculator",
  "construction-septic-tank-calculator",
  "construction-skirting-length-calculator",
  "construction-soakaway-calculator",
  "construction-soil-bearing-calculator",
  "construction-spoil-removal-calculator",
  "construction-spreader-beam-calculator",
  "construction-sprinkler-system-calculator",
  "construction-storm-drain-calculator",
  "construction-structural-opening-calculator",
  "construction-subfloor-area-calculator",
  "construction-temporary-support-calculator",
  "construction-thermal-mass-calculator",
  "construction-topsoil-volume-calculator",
  "construction-towel-rail-calculator",
  "construction-underfloor-heating-calculator",
  "construction-valley-rafter-calculator",
]);

export const CONSTRUCTION_WAVE1_REPLACEMENTS: Readonly<Record<string, string>> =
  Object.freeze({
    "construction-air-source-calculator": "construction-heat-pump-calculator",
    "construction-architrave-length-calculator": "construction-fence-length-calculator",
    "construction-asphalt-area-calculator": "construction-paving-area-calculator",
    "construction-balustrade-calculator": "construction-fence-length-calculator",
    "construction-bathroom-ventilation-calculator": "construction-air-change-rate-calculator",
    "construction-battery-storage-calculator": "construction-ev-charger-calculator",
    "construction-block-count-calculator": "construction-tile-count-calculator",
    "construction-brick-count-calculator": "construction-tile-count-calculator",
    "construction-cesspit-calculator": "construction-swimming-pool-volume-calculator",
    "construction-cold-bridge-calculator": "construction-condensation-risk-calculator",
    "construction-collar-tie-calculator": "construction-rafter-length-calculator",
    "construction-column-load-calculator": "construction-footing-size-calculator",
    "construction-cylinder-size-calculator": "construction-hot-water-tank-calculator",
    "construction-deck-boards-calculator": "construction-paving-area-calculator",
    "construction-decking-area-calculator": "construction-paving-area-calculator",
    "construction-door-frame-calculator": "construction-fence-length-calculator",
    "construction-drainage-gradient-calculator": "construction-pipe-size-calculator",
    "construction-drywall-sheets-calculator": "construction-tile-count-calculator",
    "construction-excavation-calculator": "construction-gravel-volume-calculator",
    "construction-foundation-depth-calculator": "construction-footing-size-calculator",
    "construction-garden-wall-calculator": "construction-paving-area-calculator",
    "construction-grey-water-calculator": "construction-rainwater-harvesting-calculator",
    "construction-ground-source-calculator": "construction-heat-pump-calculator",
    "construction-gully-spacing-calculator": "construction-pipe-size-calculator",
    "construction-handrail-length-calculator": "construction-fence-length-calculator",
    "construction-hardcore-base-calculator": "construction-gravel-volume-calculator",
    "construction-hip-rafter-calculator": "construction-rafter-length-calculator",
    "construction-hot-tub-size-calculator": "construction-swimming-pool-volume-calculator",
    "construction-immersion-heater-calculator": "construction-hot-water-tank-calculator",
    "construction-insulation-area-calculator": "construction-paving-area-calculator",
    "construction-inverter-size-calculator": "construction-ev-charger-calculator",
    "construction-irrigation-area-calculator": "construction-rainwater-harvesting-calculator",
    "construction-joist-spacing-calculator": "construction-steel-beam-size-calculator",
    "construction-kerb-length-calculator": "construction-fence-length-calculator",
    "construction-kitchen-extract-calculator": "construction-air-change-rate-calculator",
    "construction-landscaping-area-calculator": "construction-paving-area-calculator",
    "construction-lawn-seed-calculator": "construction-paving-area-calculator",
    "construction-lintel-size-calculator": "construction-steel-beam-size-calculator",
    "construction-mortar-mix-calculator": "construction-gravel-volume-calculator",
    "construction-mvhr-system-calculator": "construction-air-change-rate-calculator",
    "construction-padstone-calculator": "construction-footing-size-calculator",
    "construction-pile-cap-calculator": "construction-footing-size-calculator",
    "construction-plaster-area-calculator": "construction-paving-area-calculator",
    "construction-purlin-spacing-calculator": "construction-steel-beam-size-calculator",
    "construction-radiator-size-calculator": "construction-boiler-output-calculator",
    "construction-render-area-calculator": "construction-paving-area-calculator",
    "construction-retaining-wall-calculator": "construction-footing-size-calculator",
    "construction-roof-pitch-calculator": "roof-pitch-area-calculator",
    "construction-room-area-calculator": "construction-flooring-area-calculator",
    "construction-scaffold-area-calculator": "construction-paving-area-calculator",
    "construction-screed-volume-calculator": "construction-gravel-volume-calculator",
    "construction-septic-tank-calculator": "construction-swimming-pool-volume-calculator",
    "construction-skirting-length-calculator": "construction-fence-length-calculator",
    "construction-soakaway-calculator": "construction-rainwater-harvesting-calculator",
    "construction-soil-bearing-calculator": "construction-footing-size-calculator",
    "construction-spoil-removal-calculator": "construction-gravel-volume-calculator",
    "construction-spreader-beam-calculator": "construction-steel-beam-size-calculator",
    "construction-storm-drain-calculator": "construction-pipe-size-calculator",
    "construction-subfloor-area-calculator": "construction-flooring-area-calculator",
    "construction-thermal-mass-calculator": "construction-air-change-rate-calculator",
    "construction-topsoil-volume-calculator": "construction-gravel-volume-calculator",
    "construction-towel-rail-calculator": "construction-boiler-output-calculator",
    "construction-underfloor-heating-calculator": "construction-air-change-rate-calculator",
    "construction-valley-rafter-calculator": "construction-rafter-length-calculator",
  });
